module.exports = __webpack_public_path__ + "static/img/preview-02.9956fa83.webp";